module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAAnUlEQVQ4je3RPQ4BQRyG8Z/lFBqJc1BRKVVcQeIMPg5hz6ChVWnIHoCTaDfZRDOSMT6iln27Z/7vM5mPRlEUkvRwiriPc1zIUuOX1FIt/b/UQgfNaK2ddNroRly1MMLmy8bbhGcZcqx+PNka+eNOyyB/S44Fzw8xx+6DsA9zqVRhimMiHDEJ8xcJSoxxCXwNXMald/90wxAHDAI/5Q5TdhoIu3VkHAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/icon_arrow_down01.png
// module id = f7B6
// module chunks = 0